import { combineReducers } from 'redux';
import config from './config';
import content from './content';
import layout from './layout';
import carousel from './carousel';
import products from './products';
import account from './account';
import wishlist from './wishlist';
import edition from './edition';
import categorised from './categorised';
import stories from './stories';
import countdown from './countdown';
import waitlist from './waitlist';
import menus from './menus';
import audio from './audio';
import salesbanner from './salesbanner';
import greenhouse from './greenhouse';
import favouritedBrands from './favouritedBrands';
import sponsoredBrands from './sponsoredBrands';

export default combineReducers({
  config,
  content,
  layout,
  carousel,
  products,
  account,
  wishlist,
  edition,
  categorised,
  stories,
  countdown,
  waitlist,
  menus,
  audio,
  salesbanner,
  greenhouse,
  favouritedBrands,
  sponsoredBrands,
});
